import React from 'react';
import styled from 'styled-components';

const Wrap = styled.div`
	display: table;
	width: 100%;
	position: relative;
`;

export default ({ children }) => <Wrap>{children}</Wrap>;
